import React, { Fragment } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';

import Videos from 'videos/components/Main';

const App = () => (
  <Fragment>
    <CssBaseline />
    <Videos />
  </Fragment>
);

export default App;
